import { createActions } from '../../utils';

let resources = [
  'auto brands',
  'auto models',
  'auto types',
  'auto years',
  'plans',
  'compare plans',
  'auto range price',
  'additional benefits',
  'plan and insurance providers',
],
  otherActions = [
    'update plan compare status',
    'error loading auto range price',
    'error loading plans',
    'reset plans',
    'reset additional benefits',
    'error loading additional benefits',
    'reset compare plans',
    'error loading compare plans',
    'error loading plan and insurance providers',
  ];

export default createActions(resources, otherActions);
